// Schedule calendars (back/routes/scheduleCalendars.js): which days each
// crew works. The first GET on a project seeds the three presets, so a
// page never has to handle "there are no calendars yet".
import { url, tokenRef } from "api";

const headers = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem(tokenRef)}`,
});
const handle = async (r) => {
  const d = await r.json();
  if (!r.ok) { const e = new Error(d.err || "Request failed"); e.status = r.status; throw e; }
  return d;
};

export const listCalendars = async (projectId) =>
  handle(await fetch(`${url}/projects/${projectId}/calendars`, { headers: headers() }));

export const createCalendar = async (projectId, body) =>
  handle(await fetch(`${url}/projects/${projectId}/calendars`, { method: "POST", headers: headers(), body: JSON.stringify(body) }));

export const updateCalendar = async (projectId, id, body) =>
  handle(await fetch(`${url}/projects/${projectId}/calendars/${id}`, { method: "PATCH", headers: headers(), body: JSON.stringify(body) }));

export const setDefaultCalendar = async (projectId, id) =>
  handle(await fetch(`${url}/projects/${projectId}/calendars/${id}/default`, { method: "POST", headers: headers() }));

export const deleteCalendar = async (projectId, id) =>
  handle(await fetch(`${url}/projects/${projectId}/calendars/${id}`, { method: "DELETE", headers: headers() }));

// What computeSchedule's fourth argument wants.
export const toEngineOptions = (rows) => {
  const calendars = {};
  let defaultCalendarId = null;
  for (const c of rows || []) {
    const id = String(c._id);
    if (c.isDefault && !defaultCalendarId) defaultCalendarId = id;
    calendars[id] = {
      workdays: c.workdays || [1, 2, 3, 4, 5],
      hoursPerDay: c.hoursPerDay || 8,
      holidays: c.holidays || [],
    };
  }
  return { calendars, defaultCalendarId };
};

// "Mon-Fri · 8h", "Mon-Sat · 10h", "Every day · 24h" - the shape of the
// week at a glance, without having to open the calendar.
const DOW = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const describeCalendar = (c) => {
  if (!c) return "";
  const days = [...(c.workdays || [])].sort((a, b) => a - b);
  let label;
  if (days.length === 7) label = "Every day";
  else if (days.length === 0) label = "No working days";
  else {
    // A contiguous run reads as a range; anything else lists the days.
    const contiguous = days.every((d, i) => i === 0 || d === days[i - 1] + 1);
    label = contiguous && days.length > 2
      ? `${DOW[days[0]]}-${DOW[days[days.length - 1]]}`
      : days.map((d) => DOW[d]).join(", ");
  }
  return `${label} · ${c.hoursPerDay || 8}h`;
};
